module.exports = __webpack_public_path__ + "img/287.5952f45d.jpg";